"use client";
import dynamic from "next/dynamic";
import { useCallback, useMemo, useState } from "react";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger } from "@/components/ui/popover";
import Indicator from "@/components/CustomUI/modules/Loaders/Indicator";
import { convertSearchParamsToString } from "@/lib/utils";
import sortOptions from "./options.json";
const Container = dynamic(() => import("./Container"), { ssr: false });

const upClass = "toggle-up";
const downClass = "toggle-down";

const Sort = ({ metaData }) => {
  const [visible, setVisible] = useState(false);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const currentSort = useMemo(() => {
    const currentItem = sortOptions.filter(
      (ele) => ele.value === searchParams.get("sort_by")
    );
    if (currentItem.length) {
      return currentItem[0].label;
    }
    return "Relevance";
  }, [searchParams]);

  const openSortPopup = () => {
    const btn = document.getElementById("catalogSort");
    if (~btn.className.indexOf(downClass)) {
      btn.className = btn.className.replace(downClass, upClass);
    } else {
      btn.className = btn.className.replace(upClass, downClass);
    }
  };

  const createQueryString = useCallback(
    (value) => convertSearchParamsToString(searchParams, "sort_by", value),
    [searchParams]
  );

  const onOpenChange = (val) => {
    setVisible(val);
  };

  const changeSort = (value) => {
    if (value !== searchParams.get("sort_by")) {
      router.push(pathname + "?" + createQueryString(value));
    }
    onOpenChange(false);
  };

  if (!metaData || !metaData.total_items) return null;

  return (
    <Popover open={visible} onOpenChange={onOpenChange}>
      <PopoverTrigger
        asChild
        aria-controls=""
      >
        <Button
          variant="secondary"
          className="
              relative border-[0.5px] border-[#393939] h-[30px] 
              md:min-w-[150px] text-xs text-font-primaryLight 
              px-2 bg-white md:bg-[#F0FAFA] hover:drop-shadow
            "
          aria-label={`Sort by: ${currentSort}`}
          onClick={openSortPopup}
        >
          {`Sort by: ${currentSort}`}
          <div
            id="catalogSort"
            className="
              w-[20px] h-[20px] transition 
              duration-150 ease-out hover:ease-in-out 
              toggle-down ml-2 accordion-down
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20px"
              height="20px"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="
                  M6.29289 8.79289C6.68342 8.40237 7.31658 
                  8.40237 7.70711 8.79289L12 13.0858L16.2929 
                  8.79289C16.6834 8.40237 17.3166 8.40237 
                  17.7071 8.79289C18.0976 9.18342 18.0976 
                  9.81658 17.7071 10.2071L12.7071 15.2071C12.3166 
                  15.5976 11.6834 15.5976 11.2929 15.2071L6.29289 
                  10.2071C5.90237 9.81658 5.90237 9.18342 6.29289 
                  8.79289Z
                "
                fill="#393939"
              />
            </svg>
          </div>
          <Indicator show={currentSort !== "Relevance"} />
        </Button>
      </PopoverTrigger>

      <Container changeSort={changeSort} />
    </Popover>
  );
};

export default Sort;
